import {MarketingMaterialService} from "../services/MarketingMaterialService";

export class MarketingMaterialItem{

    constructor(companyId) {

        if (!companyId){
            throw new Error('[e873237] CompanyId is expected but is undefined');
        }


        this.name = '';
        this.description = '';
        this.fileId = '';
        this.isActive = true;

        this._companyId = companyId;
        this._itemId = '';
        this._uri = '';
        this._fileName = '';
        this._mimeType = '';


        this._uploaded = false;
    }

    get companyId(){
        return this._companyId;
    }

    set companyId(value){
        /* inmmutable */
    }

    get IsUploaded(){
        return this._uploaded;
    }

    set IsUploaded(value){
        /* inmmutable */
    }

    get uri(){
        return this.uri;
    }

    set uri(value){
        /* inmmutable */
    }

    get fileName(){
        return this._fileName;
    }

    set fileName(value){
        /* inmmutable */
    }

    get mimeType(){
        return this._mimeType;
    }

    set mimeType(value){
        /* inmmutable */
    }

    get itemId(){
        return this._itemId;
    }

    set itemId(value){
        /* inmmutable */
    }


    setFile(itemId, uri, filename, mimeType){
        this._itemId = itemId;
        this._uri = uri;
        this._fileName = filename;
        this._mimeType = mimeType;
        this._uploaded = true;
    }

    activate(auth){
        let vm = this;
        return new Promise((resolve, reject) => {
            try {
                let service = new MarketingMaterialService(auth);
                service.changeActiveStatus(vm.itemId, true).then(data => {
                        vm.isActive = true;
                        resolve();
                    }
                ).catch(error => {
                    console.error('[e006908] Error when submitting activate post to server.');
                    if (error) {
                        console.error(error);
                    }
                    reject(error);
                });
            }
            catch(err){
                console.error('[e935634] Internal Exception');
                if (err){
                    console.error(err);
                }

                reject(err);
            }
        });
    }

    deactivate(auth) {

        if (!auth){
            throw new Error('[e677657] auth argument is required')
        }

        console.debug('[d400303] deactivating item');
        let vm = this;
        return new Promise((resolve, reject) => {
            try {
                let service = new MarketingMaterialService(auth);
                service.changeActiveStatus(vm.itemId, false).then(data => {
                        vm.isActive = false;
                        resolve();
                    }
                ).catch(error => {
                    console.error('[e406081] Error when submitting deactivate post to server.');
                    if (error) {
                        console.error(error);
                    }
                    reject(error);
                });
            }
            catch(err){
                console.error('[e9314585] Internal Exception');
                if (err){
                    console.error(err);
                }

                reject(err);
            }
        });
    }

    delete(auth){

        let vm = this;
        return new Promise((resolve, reject) => {

            let service = new MarketingMaterialService(auth);
            service.deleteItem(this.itemId).then(data => {
                let itemId = vm.itemId;
                resolve(itemId);
                vm.__resetInstance();
            }).catch(error => {
                console.error('[e012927] failure to delete item on the server');
                if (error){
                    console.error(error);
                }
            });
        });
    }

    save(auth){
        let service = new MarketingMaterialService(auth);
        return service.save(this);
    }

    getDownloadUrl(auth){
        let service = new MarketingMaterialService(auth);
        return service.getDownloadUrl(this.itemId);
    }

    /**
     * Returns true if a file exists in the server,
     * false otherwise.
     * @param auth
     * @returns {Promise<boolean>}
     */
    existsFile(auth){
        let service = new MarketingMaterialService(auth);
        return service.existFile(this.itemId);
    }

    __resetInstance(){
        this.name = '';
        this.description = '';
        this.fileId = '';
        this.isActive = true;
        this._uri = '';
        this._fileName = '';
        this._mimeType = '';
        this._uploaded = false;
    }

    static getItemsForCompany(auth, companyId){
        let service = new MarketingMaterialService(auth);
        return service.getItems(companyId);
    }
}